import Image from '@components/ui/image'
import Container from '@components/ui/layout/Container'
import { urlFor } from '@lib/sanity/url-for'
import { MotionValue } from 'framer-motion'
import React, { FC, useEffect, useRef, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import { HowItWorksSingleton } from '__generated__/sanity'
import { SectionHeading } from '../section-heading'
import { Labels } from './Labels'
import * as styles from './styles'

type CloserLookProps = HowItWorksSingleton['fields']['closerLook'] & {
  scrollY: MotionValue<number>
}

export const CloserLook: FC<CloserLookProps> = ({
  closerLookTitle,
  closerLookDescription,
  closerLookImage,
  scrollY,
}) => {
  const [start, setStart] = useState<number | null>(null)
  const [windowHeight, setWindowHeight] = useState<number | null>(null)
  const containerRef = useRef<HTMLElement>()
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  })

  useEffect(() => {
    calculateValues()

    window.addEventListener('resize', calculateValues)

    return () => {
      window.removeEventListener('resize', calculateValues)
    }
  }, [inView])

  return (
    <section ref={inViewRef}>
      <SectionHeading title={closerLookTitle} description={closerLookDescription} />
      <Container as="div" className={styles.imageContainer} innerRef={containerRef}>
        <Image
          placeholderSrc={urlFor(closerLookImage).width(20).url()}
          alt=""
          sources={[
            urlFor(closerLookImage).width(620).url(),
            urlFor(closerLookImage).width(1024).url(),
            urlFor(closerLookImage).width(1440).url(),
            urlFor(closerLookImage).width(1800).url(),
          ]}
          ratio={[0.5]}
        />
        <Labels start={start} windowHeight={windowHeight} scrollY={scrollY} />
      </Container>
    </section>
  )

  function calculateValues() {
    if (containerRef && containerRef.current) {
      // @ts-ignore
      const rect = containerRef.current.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      setStart(rect.top + scrollTop - window.innerHeight)
      setWindowHeight(window.innerHeight)
    }
  }
}
